export default function () {
  const navbarElement = document.getElementById("navbar");
  let prevScrollPos = 0;
  let currentScrollPos = window.scrollY;

  if(!navbarElement) return;

  window.onscroll = () => {
    currentScrollPos = window.scrollY;

    if (prevScrollPos > currentScrollPos) {
      navbarElement.classList.remove("hide");
      console.log("show navbar");
    } else {
      navbarElement.classList.add("hide");
    }

    if(currentScrollPos != 0) {
      navbarElement.classList.add("drop-shadow-sm");
    } else {
      navbarElement.classList.remove("drop-shadow-sm");
    }

    prevScrollPos = currentScrollPos;
  };
}
